module.exports = __webpack_public_path__ + "static/hill_giant-fe20441d40edf48c528936134e57e754.jpg";